<template>
  <el-container class="height100">
    <el-header class="obpm-header-t">
      <admin_header />
    </el-header>
    <el-main class="height100 overflowYHidden">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav">
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>
        <el-breadcrumb-item>
          <template >
            <i @click="onreturnBtn" style="font-style:normal;" class="pointer">{{$t('systemCon')}}</i>
          </template>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-tabs class="systemCon" v-model="activeName" type="card" @tab-click="handleClick" ref="tab">
        <el-row ref="btn" v-if="isBtn"> 
          <el-col :span="24" style="text-align:right" class="nav-btn">
            <el-button type="primary" @click="onRefreshBtnClick" size="small">{{$t('refresh')}}</el-button>
            <el-button type="primary" @click="onImportBtnClick" size="small" plain>{{$t('import')}}</el-button>
            <el-button type="primary" @click="onExportBtnClick" size="small" plain>{{$t('export')}}</el-button>
            <el-button type="primary" @click="onSaveBtnClick" size="small">{{$t('save')}}</el-button>
            <el-button @click="onBackBtnClick" size="small" type="primary" plain>{{$t('exit')}}</el-button>
          </el-col>
        </el-row>
        <el-tab-pane :label="$t('authConfig')" name="setting" class="setting" v-if="(isOpen && isAdmin) ||(isOpen && !isSecret) || !isOpen" >
          <setting :detail="authConfig" @changeLdap="changeLdap"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('LDAP')" name="LDAP"  v-if="LdapVisible" >
          <LDAP :detail="ldapConfig"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('policy')" name="policy" class="policy"  v-if="(isOpen && !isAdmin) ||(isOpen && isSecret) || !isOpen" >
          <policy :detail="loginConfig"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('manage')" name="manage" class="manage"  v-if="(isOpen && isAdmin) ||(isOpen && !isSecret) || !isOpen" >
          <manage/>
        </el-tab-pane>
        <el-tab-pane :label="$t('hxImConfig')" name="config" class="config"  v-if="(isOpen && isAdmin) ||(isOpen && !isSecret) || !isOpen" >
          <config :detail="hxImConfig"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('SystemFile')" name="systemfile" class="systemfile"  v-if="(isOpen && isAdmin) ||(isOpen && !isSecret) || !isOpen">
          <systemfile :detail="SystemFile" :key="systemTimer"/>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <fileUpload :visible.sync="fileUploadVisible" v-if="fileUploadVisible" :nowOption="nowOption" @success="getData"/>

  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";
import setting from "@/components/setting.vue";
import policy from "@/components/policy.vue";
import manage from "@/components/manage.vue";
import config from "@/components/config.vue";
import LDAP from "@/components/LDAP.vue";
import systemfile from "@/components/systemfile.vue";

import fileUpload from "@/components/fileUpload.vue";

export default {
  components: {
    admin_header,
    setting,
    policy,
    manage,
    config,
    fileUpload,
    LDAP,
    systemfile
  },

  created() {
    if(this.$store.state.currentUser.isOpenSecurity) {
      this.isOpen=true;

      if (this.$store.state.currentUser.type == 'admin') {
        this.isAdmin = true;
      }else if(this.$store.state.currentUser.type == 'secret'){
        this.isSecret=true;
        this.activeName='policy';
      }
    }else{
      this.isOpen=false;

    }
    this.getData();
  },
  
  data() {
    return {
      activeName:"setting",
      systemConfig:{},
      authConfig:{},//身份验证
      loginConfig:{},//用户密码
      hxImConfig:{},//环信配置
      ldapConfig:{},//LDAP配置
      SystemFile:{},//系统字段
      fileUploadVisible:false,
      nowOption:"systemImport",
      LdapVisible:false,
      isOpen:false,//是否开启开关
      isAdmin:false,//是否系统管理员
      isSecret:false,//是否安全保密员
      isBtn:true,//是否展示操作按钮
      systemTimer:'',
    };
  },
  
  methods: {
    getData(){
      this.$api.getConfig({
        onSucess:resp =>{
          if(resp.data.errcode==0){
            this.systemConfig = resp.data;
            
            this.authConfig = this.systemConfig.data.authConfig;
            this.loginConfig = this.systemConfig.data.loginConfig;
            this.hxImConfig = this.systemConfig.data.hxImConfig;
            this.ldapConfig = this.systemConfig.data.ldapConfig;
            this.SystemFile = this.systemConfig.data.SystemFile;
            if(this.authConfig.ssoAuth=="cn.myapps.security.sso.ADUserSSO" || this.authConfig.ssoAuth=="cn.myapps.security.sso.ADUserSSOJespa"){
              this.LdapVisible=true;
            }else{
              this.LdapVisible=false;
            }
          }else{
            this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
          }
        },
        onError:function(){

        }
      })
    },
    
    handleClick(tab){
      if(tab.name=="systemfile"){
        this.isBtn = false;
        this.systemTimer = new Date().getTime();
      }else{
        this.isBtn = true;
      }
      this.activeName=tab.name
    },
    onBackBtnClick(){
      this.$router.push({ name: 'home'});
    },
    onRefreshBtnClick(){
      this.getData();
      

    },
    onImportBtnClick(){
      this.fileUploadVisible=true;
    },
    onExportBtnClick(){
      this.$api.exportConfig(()=>{
          this.$message({
            showClose: true,
            message: "导出成功",
            type: "success"
          });
      })
    },
    onSaveBtnClick(){
      this.$api.saveConfig({data:this.systemConfig},{
        onSucess:resp =>{
          if(resp.data.errcode==0){
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: "success"
            });
          }else{
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: "error"
            });
          }
          
          
        },
        onError:function(){
          
        }
      })
    },
    changeLdap(val){
      this.LdapVisible=val;
    },
    onreturnBtn(){
      this.activeName="setting";
    },

  }
};
</script>

<style>
</style>